import {
  Card, CardContent, Box, Typography, Button, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper, Avatar,
  AvatarGroup, Skeleton,
  Tooltip
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const SkeletonRow = () => (
  <TableRow>
    {[100, 150, 80, 200].map((w, i) => (
      <TableCell key={i}>
        {i === 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton width={w} />
          </Box>
        ) : (
          <Skeleton width={w} />
        )}
      </TableCell>
    ))}
  </TableRow>
);

const CollaborationRow = ({ collab, history }) => (
  <TableRow hover>
    <TableCell>
      <Box
        onClick={() => history.push('/artist-profile', { data: collab, status: '', page: 'artist' })}
        sx={{ display: "flex", alignItems: "center", gap: 2, cursor: "pointer" }}
      >
        <AvatarGroup max={3} sx={{ justifyContent: "flex-start" }}>
          <Avatar src={collab.avatar_url} alt={collab.name} sx={{ width: 32, height: 32 }} />
        </AvatarGroup>
        {collab.name}
      </Box>
    </TableCell>
    <TableCell><Typography fontWeight="bold">{collab.email}</Typography></TableCell>
    <TableCell>{collab.primary_category}</TableCell>
    <TableCell>
      <Tooltip title={collab.about} arrow>
        <Typography sx={{ color: '#797979', fontSize: '14px', flexWrap: 'wrap', display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 4, }}>
          {collab.about}
        </Typography>
      </Tooltip>
    </TableCell>
  </TableRow >
);

export const CollaborationsSection = ({ collaborations, loading }) => {
  const history = useHistory();
  const userData = useSelector((state) => state.userData.userData);

  return (
    <Card sx={{ mb: 4 }}>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          {loading ? (
            <>
              <Skeleton width={150} height={32} />
              <Skeleton width={200} height={36} sx={{ borderRadius: 2 }} />
            </>
          ) : (
            <>
              <Typography variant="h5" fontWeight="bold">Collaborations({collaborations.length})</Typography>
              {userData?.enable_distribution ? <a href="/collaboration" className="gn-actionbtn-color ">
                View All Collaborations
              </a> : null}
            </>
          )}
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: "none", border: 1, borderColor: "divider" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>About</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                Array.from({ length: 3 }).map((_, i) => <SkeletonRow key={i} />)
              ) : collaborations.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="h6" color="text.secondary">No collaborations found</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Request collaborations to expand your network
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                collaborations.slice(0, 3).map((collab) => (
                  <CollaborationRow key={collab.id} collab={collab} history={history} />
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};
